var jsts = require("jsts");
var rbush = require("rbush");

var Collections = require("./src/collections");

var SpatialIndex = function (type, col, getGeom, getUpdateTriggers, trigger, beforeQuery) {
    var self = this;

    // TODO: verify whether col is a versioned collection
    this.collection = col;
    this.getGeom = getGeom;
    this.getUpdateTriggers = getUpdateTriggers || function () { return []; };
    this.beforeQuery = beforeQuery;

    this.type = type;

    switch(this.type) {
        case "quadtree":
            this._index = new jsts.index.quadtree.Quadtree();
            break;
        case "strtree":
            this._index = new jsts.index.strtree.STRtree();
            break;
        case "rbush":
            this._index = rbush();
            break;
        default:
            throw new Error("unknown spatial index type");
    }

    this.invalidElements = new Collections.HashSet();
    this.currentIndexedItemMap = new Collections.HashMap();

    var attachUpdateTriggers = function (element) {
        var triggers = self.getUpdateTriggers(element);
        var invalidate_index = function () {
            self.invalidElements.add(element);
        };
        if(triggers) {
            triggers.forEach(function (trigger) {
                trigger[1].call(trigger[0], self, invalidate_index);
            });
        }
    };

    var removeUpdateTriggers = function (element) {
        var triggers = self.getUpdateTriggers(element);
        if(triggers) {
            triggers.forEach(function (trigger) {
                trigger[0].removeHandlers(self);
            });
        }
    };

    col.forEach(function(key, element) {
        self._insert(element);
        attachUpdateTriggers(element);
    });

    col.onAdd(this, function(key, element) {
        self._insert(element);
        attachUpdateTriggers(element);
    });

    col.onRemove(this, function(key, element) {
        self._remove(element);
        removeUpdateTriggers(element);
    });

    this.update();

    this.autoupdate = true;
    if(trigger) {
        trigger(function () {
            self.update();
        });
        this.autoUpdate = false;
    }
};

module.exports = SpatialIndex;

SpatialIndex.prototype._remove = function (element) {
    var currentIndexedItem = this.currentIndexedItemMap.get(element);
    switch(this.type) {
        case "rbush":
            if(currentIndexedItem) {
                this._index.remove(currentIndexedItem);
                this.currentIndexedItemMap.remove(element);
            }
            break;
        case "quadtree":
        case "strtree":
            if(currentIndexedItem) {
                if(!this._index.built)
                    this._index.remove(currentIndexedItem, element);
                else
                    this.forceUpdateNextQuery = true;
                this.currentIndexedItemMap.remove(element);
            }
            break;
        default:
            throw new Error("unknown type");
    }
    this.invalidElements.remove(element);
};

SpatialIndex.prototype._insert = function (element) {
    var geom = this.getGeom(element);
    if(geom) {
        var item = null;
        switch(this.type) {
            case "quadtree":
                item = geom.toJsts();
                this._index.insert(item, element);
                break;
            case "strtree":
                item = geom.toJsts();
                if(!this._index.built)
                    this._index.insert(item, element);
                else
                    this.forceUpdateNextQuery = true;
                break;
            case "rbush":
                var rBushElement = {
                    minX: geom.getXMin(),
                    minY: geom.getYMin(),
                    maxX: geom.getXMax(),
                    maxY: geom.getYMax(),
                    el: element
                };
                this._index.insert(rBushElement);
                item = rBushElement;
                break;
            default:
                throw new Error("unknown type");
        }
        this.currentIndexedItemMap.put(element, item);
    }
};

SpatialIndex.prototype.update = function (forced) {
    var self = this;

    var updateIndex = function (element) {
        // remove old value
        var currentIndexedItem = self.currentIndexedItemMap.get(element);
        if(currentIndexedItem) {
            self._index.remove(currentIndexedItem);
            self.currentIndexedItemMap.remove(element);
        }
        // add new value
        self._insert(element);
    };

    switch(this.type) {
        case "quadtree":
        case "rbush":
            while (this.invalidElements.size()) {
                var element = this.invalidElements.pop();
                if(element.isAlive && element.isAlive()) {
                    console.assert(this.collection.contains(element), "WTF: element is not in spatial index collection!!");
                    updateIndex(element);
                }
            }
            break;
        case "strtree":
            if(this.invalidElements.size() || forced) {
                this._index = new jsts.index.strtree.STRtree();
                this.currentIndexedItemMap.keys().forEach(function(key) {
                    updateIndex(key);
                });
            }
            this.invalidElements.removeAll();
            break;
        default:
            throw new Error("unknown type");
    }
};

SpatialIndex.prototype.query = function (geom) {
    var self = this;

    if(this.beforeQuery) this.beforeQuery();
    if(this.autoupdate) this.update(this.forceUpdateNextQuery);
    this.forceUpdateNextQuery = false;

    switch(self.type) {
        case "quadtree":
        case "strtree":
            return self._index.query(geom.toJsts()).array_;
        case "rbush":
            var res = self._index.search({
                minX: geom.getXMin(),
                minY: geom.getYMin(),
                maxX: geom.getXMax(),
                maxY: geom.getYMax()
            });
            return res.map(function (ent) { return ent.el; });
        default:
            throw new Error("unknown type");
    }
};
